import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, lifecycle } from 'recompose'

import {
  fetchCalendarStatus,
  fetchMicrosoftAdminConsent,
  openedMeetingEmailModal,
  fetchMeetingSettings,
  fetchMeetingTypes
} from 'app/modules/meetings/actions'

import { fetchGoogleScopes } from 'app/modules/user/actions'

import {
  isGoogleOrMicrosoftConnected,
  getIsGoogleOauthConnected,
  getIsMicrosoftOauthConnected,
  hasFetchedMicrosoftAdminConsent,
  getCalendarStatusLoaded,
  getCalendar
} from 'app/modules/meetings/selectors'

import CalendarAdvanced from './component'

function makeMapStateToProps() {
  return state => ({
    isGoogleOrMicrosoftConnected: isGoogleOrMicrosoftConnected(state),
    googleAuthed: getIsGoogleOauthConnected(state),
    microsoftAuthed: getIsMicrosoftOauthConnected(state),
    microsoftAdminManaged: hasFetchedMicrosoftAdminConsent(state),
    getCalendarStatusLoaded: getCalendarStatusLoaded(state),
    calendar: getCalendar(state),
  })
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        fetchCalendarStatus,
        fetchMicrosoftAdminConsent,
        openedMeetingEmailModal,
        fetchGoogleScopes,
        fetchMeetingSettings,
        fetchMeetingTypes
      },
      dispatch
    ),
  }
}

export default compose(
  connect(makeMapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      if (!this.props.isCalendarLoaded || !this.props.isSettingsLoaded || !this.props.isMeetingTypesLoaded) {
        this.props.actions.fetchCalendarStatus()
        this.props.actions.fetchGoogleScopes()
        this.props.actions.fetchMeetingSettings()
        this.props.actions.fetchMicrosoftAdminConsent()
        this.props.actions.fetchMeetingTypes()
      }
    },
    componentWillReceiveProps(nextProps) {
      if (!(nextProps.calendar && nextProps.calendar.id)) {
        nextProps.router.replace('/settings/calendar/connect')
      }
    }
  })
)(CalendarAdvanced)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/meetings/CalendarAdvanced/index.js